import { z } from 'zod'
import { FreitextSchema } from '../../Generic/schema/generic.schema'

const DEFAULT_AUFTRAG_X_95 = {
  enabled: false,
  freitext: ''
}

export const AuftragX_95Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_X_95.enabled),
    freitext: FreitextSchema
  })
  .default(DEFAULT_AUFTRAG_X_95)

export type AuftragX_95Data = z.infer<typeof AuftragX_95Schema>
